import {miniSerializeError} from '@reduxjs/toolkit';
import {CancelledError} from '@tanstack/query-core';
import {getSerializedPagewebError} from './getSerializedPagewebError.function';
import {PagewebError} from './PagewebError.class';
import {PagewebErrorType} from './PagewebErrorType.enum';
import {SerializedPagewebError} from './SerializedPagewebError.interface';

export function thunkSerializeError(error: unknown): SerializedPagewebError {
  if (error instanceof PagewebError) {
    // 일반적인 thunk는 apolloError(CombinedError)로 처리됩니다. axios로 요청하는 예외적인 상황도 처리하게 PagewebError도 추가해줍니다.
    return getSerializedPagewebError(error);
  } else if (error instanceof CancelledError) {
    return {
      isSerializedPagewebError: true,
      type: PagewebErrorType.CancelledError,
      message: 'cancelled error',
    };
  } else {
    return getSerializedPagewebError(miniSerializeError(error));
  }
}
